import Box from "../Box";
import Autocomplete from "../Autocomplete";
import Helpers from "../../commons/helpers";
import useStrings from "../../hooks/useStrings";

import { Constants } from "../../constants/constants";
import { useCommonComponentContext } from "../../providers/CommonComponentProvider";

interface Props {
    defaultLanguage?: string;
    onChangeLanguage?: (value: string) => void;
}

const SelectMultiLanguage: React.FC<Props> = (props: Props) => {
    const {
        listMultiLanguage,
    } = useCommonComponentContext();
    const strings = useStrings();

    return (
        <Box width="150px" sx={{ mt: { xs: "16px", sm: "0px" }, ml: "auto" }} >
            <Autocomplete
                size="small"
                isSelectedBox
                variant="outlined"
                data={listMultiLanguage}
                label={strings.Common.MULTI_LANGUAGE}
                defaultValue={props.defaultLanguage || Constants.DefaultLanguage}
                onChange={(newValue) => {
                    Helpers.isFunction(props.onChangeLanguage) && props.onChangeLanguage(newValue);
                }}
            />
        </Box>
    );
}

export default SelectMultiLanguage;